module.exports = __webpack_public_path__ + "img/outdoor-fuji.1d9e96c0.jpg";